import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import LogoTitle from '../../assets/images/mid_initial.png'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'
import Logo from './Logo'
import './index.scss'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const firstNameArray = ['B', 'l', 'a', 'y', 'n', 'e']
  const lastNameArray = ['G', 'o', 'w', 'e', 'r', ' ', 'II']
  const jobArray = ['d', 'e', 'v', 'e', 'l', 'o', 'p', 'e', 'r']

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)

  }, [])

  return (
    <>
    <div className="container home-page">
      <div className="text-zone">
        <h1>
          <span className={letterClass}>H</span>
          <span className={`{$letterClass} _12`}>i,</span>
          <br />
          <span className={`{$letterClass} _12`}>I</span>
          <span className={`{$letterClass} _12`}>'m </span>
          <AnimatedLetters
            letterClass={letterClass}
            strArray={firstNameArray}
            idx={13}
          />
          <img src={LogoTitle} alt="developer" />
          <AnimatedLetters
            letterClass={letterClass}
            strArray={lastNameArray}
            idx={14}
          />
          <br />
          <AnimatedLetters
            letterClass={letterClass}
            strArray={jobArray}
            idx={16}
          />
        </h1>
        <h2>
          Noob Developer / Javascript Noob / Python Noob/ Networking Guru / 11th
          level Nerd
        </h2>
        <Link to="/contact" className="flat-button">
          CONTACT ME
        </Link>
      </div>
      <Logo />
    </div>
    <Loader type="pacman" />
    </>
  )
}
export default Home
